module.exports = __webpack_public_path__ + "static/offers-ba5a1f5cfc58f2d35c22d24e97409f96.jpg";